module.exports = __webpack_public_path__ + "e4a76cfac246bee54d8995bf9be93cf9.png";